import config from 'config';
import _ from 'lodash';
import axios from '@/util/axios';
import { authHeader, localStorageTokenKey, localStorageUserKey } from '@/services/authentication';
import { ONBOARDING_TYPE } from '@/constants';

function login(email, password) {
    return axios.post(
        `${config.apiUrl}/${config.apiVersion}/authenticate/login`,
        { email, password },
    ).then(({ data: token }) => {
        localStorage.setItem(localStorageTokenKey, JSON.stringify(token));
        return token;
    });
}

function register(name, email, password, phone, locale, onboardingType = ONBOARDING_TYPE.FIRST_USER, onboardingPayload = null) {
    return axios.post(
        `${config.apiUrl}/${config.apiVersion}/authenticate/register`,
        {
            name,
            email,
            password,
            phone_number: phone,
            locale,
            onboarding_type: onboardingType,
            onboarding_payload: onboardingPayload,
        },
    ).then(({ data: token }) => {
        localStorage.setItem(localStorageTokenKey, JSON.stringify(token));
        return token;
    });
}

function impersonate(token) {
    localStorage.setItem(localStorageTokenKey, JSON.stringify({ token }));
}

function me() {
    return axios.get(
        `${config.apiUrl}/${config.apiVersion}/authenticate/me`,
        { headers: authHeader() },
    ).then(({ data: user }) => {
        if (!user.timezone) {
            let timezone = 'Europe/Berlin';
            try {
                timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            } catch (e) {
                // Intl unavailable, fall back to default value;
            }
            user.timezone = timezone;
        }
        localStorage.setItem(localStorageUserKey, JSON.stringify(user));
        return user;
    });
}

function requestPasswordResetLink(email) {
    return axios.get(
        `${config.apiUrl}/${config.apiVersion}/authenticate/password/reset`,
        { params: { email } },
    ).then(({ data: token }) => token);
}

function resetPassword(email, password, password_confirmation, token) {
    return axios.put(
        `${config.apiUrl}/${config.apiVersion}/authenticate/password/reset`,
        {
            email, password, password_confirmation, token,
        },
    ).then((response) => response);
}

function clearLocalStorage() {
    // delete current jwt token
    localStorage.removeItem(localStorageTokenKey);
    localStorage.removeItem(localStorageUserKey);
}

function logout() {
    // blacklist current jwt token
    return axios.post(`${config.apiUrl}/${config.apiVersion}/authenticate/logout`)
        .then(() => {
            // delete current jwt token
            clearLocalStorage();
        });
}

export const updateUser = (user = {}) => localStorage.setItem(localStorageUserKey, JSON.stringify(user));

export const updateUserSubscription = (subscription = {}) => {
    const user = JSON.parse(localStorage.getItem(localStorageUserKey));
    _.set(user, 'subscription', subscription);
    localStorage.setItem(localStorageUserKey, JSON.stringify(user));
};
export const updateUserSubscriptionInspections = (inspection = {}) => {
    const user = JSON.parse(localStorage.getItem(localStorageUserKey));
    _.set(user, 'subscription.inspections', inspection);
    localStorage.setItem(localStorageUserKey, JSON.stringify(user));
};

export default {
    login,
    register,
    logout,
    me,
    resetPassword,
    requestPasswordResetLink,
    impersonate,
    updateUser,
    updateUserSubscription,
    updateUserSubscriptionInspections,
    clearLocalStorage,
};
